<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters" ref="queryForm">

                <el-form-item>
                    <el-input v-model="filters.masterId" placeholder="工程师ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.type" clearable placeholder="请选择">
                        <el-option
                                v-for="item in type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <div class="block">
                        <el-date-picker
                                format="yyyy-MM-dd HH:mm:ss"
                                v-model="date"
                                type="datetimerange"
                                placeholder="请选择">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryLog">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="logData" highlight-current-row border stripe v-loading="listLoading"
                  style="width: 100%;text-align: center"  @selection-change="selsChange" :row-key="getRowKeys" >
            <el-table-column type="index" width="80">
            </el-table-column>
            <el-table-column prop="changTime" label="时间" :formatter="formatTime" width="170">
            </el-table-column>
            <el-table-column prop="type" label="类型" :formatter="formatType" min-width="120">
            </el-table-column>
            <el-table-column prop="money" label="金额" :formatter="formatMoney" min-width="120">
            </el-table-column>
            <el-table-column prop="reason" label="原因">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
            </el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    masterId: '',
                    type: '',
                    startTime: '',
                    endTime: '',
                },
                accountType: sessionStorage.getItem('type'),
                logData: [],
                merchant: [],
                type: data.masterMoneyType,
                rowCount: 30,
                page: 1,
                listLoading: false,
                date: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date()]


            }

        },
        mounted: function () {

            NProgress.start();


            let query = this.$route.query;
            if (typeof query.masterId !== 'undefined') {
                this.filters.masterId = this.$route.query.masterId;
                this.queryLog();
            }
            NProgress.done();


        },
        activated: function () {

        },

        methods: {

            formatTime: function (row, column) {
                if (row.changeTime)
                    return util.formatDate.format(new Date(row.changeTime), 'yyyy-MM-dd hh:mm:ss ');
            },
            formatType: function (row, column) {
                if (row.type == 0)
                    return '减少';
                else if (row.type == 1)
                    return '增加';

            },
            formatMoney: function (row, column) {
                if (row.money)
                    return row.money / 100;
            },
            handleCurrentChange(val) {
                this.pageNO = val;
                this.queryLog();
            },

            queryLog() {
                this.listLoading = true;
                var url = 'masterMoneyLog/queryPage.do';
                let para = Object.assign({}, this.filters);
                para.startTime = util.formatDate.format(new Date(this.date.toString().split(',')[0]), 'yyyy-MM-dd hh:mm:ss');
                para.endTime = util.formatDate.format(new Date(this.date.toString().split(',')[1]), 'yyyy-MM-dd hh:mm:ss');

                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = res.total;
                        this.logData = res.data;
                    }
                    this.listLoading = false;

                });
            }
        }
    }

</script>

<style scoped>
    .el-table th {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// masterMoneyLog.vue?4876d620